import { useQuery } from '@tanstack/react-query'
import { getCities } from '../data/api'

/* The seeded city list.

   Reference data in the truest sense — it changes when the country gains a
   city — so it is fetched once and then never asked for again for the life
   of the tab. `enabled` lets the booking dialog hold the request until it is
   actually opened: a visitor browsing the listing has no use for it. */

export const cityKeys = { all: () => ['cities'] as const }

export function useCities(enabled = true) {
  return useQuery({
    queryKey: cityKeys.all(),
    queryFn: () => getCities(),
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
  })
}
